function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useMemo, useRef, useState } from "react";
const defaultBounds = [[-0.1695, 51.4901], [-0.0905, 51.5305]];
export function useMap(locations) {
  const mapRef = useRef(null);
  const bounds = useMemo(() => getBounds(locations), [JSON.stringify(locations)]);
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedLocation = _useState2[0],
    setSelectedLocation = _useState2[1];
  function setLocation(location) {
    let adjustMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setSelectedLocation(location);
    if (!adjustMap) return;
    if (location) {
      panTo(location.longitude, location.latitude);
    } else {
      fitToBounds();
    }
  }
  function fitToBounds() {
    var _a, _b;
    if (!mapRef.current) return;
    (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.resize();
    (_b = mapRef.current) === null || _b === void 0 ? void 0 : _b.fitBounds(bounds, {
      padding: 40,
      maxZoom: locations.length ? 16 : 10
    });
  }
  function panTo(longitude, latitude) {
    var _a;
    (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.panTo([longitude, latitude]);
  }
  function getBounds(locations) {
    if (!locations.length) return defaultBounds;
    // Calculate corner values of bounds
    const longs = locations.map(_ref => {
      let longitude = _ref.longitude;
      return longitude;
    });
    const lats = locations.map(_ref2 => {
      let latitude = _ref2.latitude;
      return latitude;
    });
    const southWest = [Math.min(...longs), Math.min(...lats)];
    const northEast = [Math.max(...longs), Math.max(...lats)];
    return [southWest, northEast];
  }
  useEffect(fitToBounds, [bounds]);
  return {
    bounds,
    mapRef,
    fitToBounds,
    panTo,
    setLocation,
    selectedLocation
  };
}